<template>
    <span :class="classes"
        class="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-semibold tw-border tw-border-solid tw-capitalize">
        <span class="tw-w-1.5 tw-h-1.5 tw-rounded-full" :class="dotClass"></span>
        {{ label || status }}
    </span>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
    status: { type: String, default: '' },
    label: { type: String, default: '' },
});

const map = {
    active: 'tw-bg-emerald-50 tw-text-emerald-700 tw-border-emerald-200',
    inactive: 'tw-bg-gray-50 tw-text-gray-600 tw-border-gray-200',
    expired: 'tw-bg-amber-50 tw-text-amber-700 tw-border-amber-200',
    cancelled: 'tw-bg-rose-50 tw-text-rose-700 tw-border-rose-200',
    disabled: 'tw-bg-rose-50 tw-text-rose-700 tw-border-rose-200',
};

const dots = {
    active: 'tw-bg-emerald-500',
    inactive: 'tw-bg-gray-400',
    expired: 'tw-bg-amber-500',
    cancelled: 'tw-bg-rose-500',
    disabled: 'tw-bg-rose-500',
};

const classes = computed(() => map[props.status] || map.inactive);
const dotClass = computed(() => dots[props.status] || dots.inactive);
</script>
